import Cancelled from '@/views/borrows/cancelled/Index'
import List from '@/views/borrows/cancelled/List'
import Show from '@/views/borrows/cancelled/Show'
import Edit from '@/views/borrows/cancelled/Edit'
import Permissions from '@/permissions'

export const cancelRouters = {
  path: 'cancelled',
  name: 'cancelled',
  component: Cancelled,
  redirect: 'list-cancelled',
  meta: {
    permissions: [Permissions.backend.cancelled.manage],
    groups: 'cancelled'
  },
  children: [
    {
      path: '',
      name: 'list-cancelled',
      component: List,
      meta: {
        permissions: [Permissions.backend.cancelled.list],
        groups: 'cancelled',
        breadcrumb: [
          {
            name_en: 'Cancelled',
            name_km: 'ដែលបានបោះបង់'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'show/:borrow_id',
      name: 'show-cancelled',
      component: Show,
      meta: {
        permissions: [Permissions.backend.cancelled.edit],
        groups: 'cancelled',
        breadcrumb: [
          {
            name_en: 'Cancelled',
            name_km: 'ដែលបានបោះបង់'
          },
          {
            name_en: 'Edit',
            name_km: 'កែសម្រួល'
          }
        ]
      }
    },
    {
      path: 'edit/:borrow_id',
      name: 'edit-cancelled',
      component: Edit,
      meta: {
        permissions: [Permissions.backend.cancelled.edit],
        groups: 'cancelled',
        breadcrumb: [
          {
            name_en: 'Cancelled',
            name_km: 'ដែលបានបោះបង់'
          },
          {
            name_en: 'Edit',
            name_km: 'កែសម្រួល'
          }
        ]
      }
    }
  ]
}
